import Component_SnippetMaterial_d6fb6df5f67682eece944a700d53f08e from "../../../../content/examples/basic/snippet-material/SnippetMaterial";
import Devtool_SnippetMaterial_d6fb6df5f67682eece944a700d53f08e from "!!@devtool/loader!../../../../content/examples/basic/snippet-material/SnippetMaterial";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_SnippetMaterial_d6fb6df5f67682eece944a700d53f08e,
  Devtool_SnippetMaterial_d6fb6df5f67682eece944a700d53f08e,
  DevTool,
  React
};